<template>
    <div class="list-group-item power-box">
        <div class="row d-flex justify-content-between align-items-center mx-0" @click="visible = !visible" role=button>
            <p class="mb-0"><b>{{$t('cat.filter.power')}}</b></p>
            <component v-bind:is="getChevronTag" />
        </div>

        <b-collapse :visible="visible">
            <div class="row mt-3 mb-3">
                <div class="col-12">
                    <div class="d-inline">
                        kW
                        <b-form-checkbox
                            name="check-button" class="d-inline"
                            v-model="powerType"
                            :value="getPowerUnit"
                            v-on:change="switchType()"
                            unchecked-value="kW"
                            switch
                        ></b-form-checkbox>
                       {{getPowerUnit}}
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group relative">
                        <div class="row">
                            <div class="col-12">
                                <b-skeleton v-if="isLoading && value === null" height="14px" width="100%" class="mb-3"></b-skeleton>
                                <vue-slider :min="min" :max="getSliderMaxValue" v-model="value" :enableCross="false" class="mb-3" v-if="value.length" v-on:change="update()"
                                    silent lazy tooltip="none"></vue-slider>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 d-flex justify-content-between" v-if="isLoading">
                                <b-skeleton height="1rem" width="20%"></b-skeleton>
                                <b-skeleton height="1rem" width="20%"></b-skeleton>
                            </div>
                            <div class="col-12 d-flex justify-content-between" v-if="!isLoading">
                                <span>{{ getMinValue }}</span>
                                <span>{{ getMaxValue }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import { BFormCheckbox } from "bootstrap-vue";
import { BCollapse, BIconChevronUp, BIconChevronDown, BSkeleton } from "bootstrap-vue";
import { EventBus } from "../../event-bus";
import VueSlider from "vue-slider-component";

export default {
    name: 'FilterPowerBox',
    components: {
        BFormCheckbox,
        BCollapse, BIconChevronUp, BIconChevronDown,
        BSkeleton,
        VueSlider
    },
    data() {
        return {
            powerType: 'kW',
            changedByUrl: false,
            factor: 1,
            isLoading: true,
            filterData: null,
            min: 0,
            max: 100,
            visible: false,
            value: []
        }
    },
    computed: {
        isHorsepower() {
            return this.powerType === 'PS' || this.powerType === 'HP';
        },
        isKilowatts() {
            return this.powerType === 'kW';
        },
        getPowerUnit(){
            return this.$root.whitelabel.getPowerUnit()
        },
        appendUnit() {
            return this.powerType == 'kW' ? 'kW' : this.$root.whitelabel.getPowerUnit()
        },
        getChevronTag() {
            return this.visible ? "b-icon-chevron-up" : "b-icon-chevron-down";
        },
        getMinValue() {
            return this.value ? `${this.value[0]} ${this.powerType}` : ''
        },
        getMaxValue() {
            return this.value ? `${this.value[1]} ${this.powerType}` : ''
        },
        getSliderMaxValue() {
            return this.value ? Math.round(this.max / this.factor) : 0
        }
    },
    methods: {
        initPowerType(){
            const query = this.$route.query.power_type
            if(query && query === 'kW' || query === 'PS'  || query === 'HP' ){
                this.powerType = query
            } else {
                this.powerType = this.$root.whitelabel.getPowerUnit()
            }
        },
        getFilterData(data) {
            this.filterData = data.find(f => f.name === 'power')
            this.initPowerType()
            this.max = this.filterData.interval_max

            if (this.$route.query['power']) {
                this.changedByUrl = true
                const queryValues = this.$route.query['power'].replace(/[^0-9\,]/g, '').split(',')

                if ((queryValues.length == 1 && queryValues[0] == "1") || queryValues[0] > this.max || queryValues[1] > this.max) {
                    this.value = [0, 0, this.max]
                } else {
                    this.value = [Number(queryValues[1]), Number(queryValues[2])]
                }
            } else {
                this.value = [0, this.max]
            }

            this.isLoading = false
        },
        switchType () {
            this.setFactor()
            const max = Math.round(this.max / this.factor)
            const string = `[1,0,${max.toFixed(0)}]`
            this.value = [0, max]

            EventBus.$emit('update-catalog-filter', { filter:"power_type", value: this.powerType })
            EventBus.$emit('update-catalog-filter', { filter:"power", value: string });
        },
        initVisibleState() {
            this.visible = this.$route.query.power !== undefined || this.$route.query.power_type !== undefined
        },
        setFactor() {
            this.factor = this.powerType == 'kW' ? 1.36 : 1
        },
        update() {
            const min = Math.round(this.value[0] / this.factor)
            const max = Math.round(this.value[1] / this.factor)
            const string = `[1,${min.toFixed(0)},${max.toFixed(0)}]`

            EventBus.$emit('update-catalog-filter', { filter:"power_type", value: this.powerType })
            EventBus.$emit('update-catalog-filter', { filter:"power", value: string });
        },
    },
    mounted() {
        this.initPowerType()
        this.setFactor()
        this.initVisibleState()

        EventBus.$on('catalog-filters-received', this.getFilterData);
        EventBus.$on('catalog-filters-received-modal', this.getFilterData);
        EventBus.$on('catalog-filters-reset', this.resetFilter);
    }
}
</script>
